import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 44 44" {...props}><path d="M36.5 4.6a2.05 2.05 0 012.9 2.9L24.9 22l14.5 14.5a2.05 2.05 0 01-2.9 2.9L22 24.9 7.5 39.4a2.05 2.05 0 01-2.9-2.9L19.1 22 4.6 7.5a2.05 2.05 0 012.9-2.9L22 19.1 36.5 4.6z" /></svg>);